import React from 'react';
import { connect } from 'react-redux';
import { isEmpty, cloneDeep } from 'lodash';

import PlaceList from '../molecules/places/PlaceList';
import PlaceDetails from '../molecules/places/PlaceDetails';
import ACSaveBar from '../atoms/ACSaveBar';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import { getPlaces, getPlace, postPlace, patchPlace } from '../common/actions/places';
import { uploadMedia } from '../common/actions/medias';
import { getFilterStr, getMediaForUIName, getLatestMedia, isLastMediaSame } from '../common/global';

import styles from './PlacesPage.module.scss';

class PlacesPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      places: [],
      place: {},

      // updateData is used to store update data field
      updateData: {},
      // Confirmation dialog related states
      openDialog: false,
      selection: {},

      // Alert dialog related states
      openAlertDialog: false,
      errors: [],
    };
  }

  componentDidMount() {
    const { id, getPlacesFunc, getPlaceFunc } = this.props;
    getPlacesFunc();
    if (id && !isEmpty(id)) {
      getPlaceFunc(id);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      places = [],
      place = {},
      filter = {},
      isRefreshRequired = false,
      getPlacesFunc,
    } = this.props;

    if (prevProps.places !== places) {
      this.setState({ places });
    }
    if (prevProps.place !== place) {
      // extract top media to ease later manipulation
      const medias = place.medias || [];
      let media = place.media || { type: 'image', url: '' };
      place.media = getLatestMedia(medias, media);

      this.setState({ place });
    }
    if (
      prevProps.filter !== filter ||
      (prevProps.isRefreshRequired !== isRefreshRequired && isRefreshRequired === true)
    ) {
      let { keyword = '' } = this.state;
      let filterStr = getFilterStr(filter);
      if (!isEmpty(keyword)) filterStr += '&keyword=' + keyword;
      getPlacesFunc(filterStr);
    }
  }

  onChangeSearchText = event => {
    const { filter = {}, getPlacesFunc } = this.props;
    const searchText = event.target.value;
    let filterStr = getFilterStr(filter);
    filterStr += '&keyword=' + searchText;

    getPlacesFunc(filterStr);

    this.setState({
      searchText,
    });
  };

  onSelectPlace = place => {
    if (!isEmpty(this.state.updateData)) {
      this.setState({
        openDialog: true,
        selection: place,
      });
      return;
    }

    // Internal update
    this.setState({
      place,

      // Reset updateData
      updateData: {},
    });
  };

  onClickDialogYes = () => {
    this.resetUnSavedDataFlag();
    this.setState(
      {
        openDialog: false,
        // Reset updateData
        updateData: {},
      },
      // Callback function has been used to make the selection,
      // if the user decides to leave the changes.
      () => {
        this.onSelectPlace(this.state.selection);
      }
    );
  };

  onClickDialogNo = () => {
    this.setState({
      openDialog: false,
    });
  };

  onClickAlertDialogClose = () => {
    this.setState({
      openAlertDialog: false,
    });
  };

  onClickAlertDialogClose = () => {
    this.setState({
      openAlertDialog: false,
    });
  };

  onUpdateInternalStates = updatedPlace => {
    let { places = [], place = {}, updateData = {} } = cloneDeep(this.state);

    place = cloneDeep(updatedPlace);
    updateData = cloneDeep(updatedPlace);

    const index = places.findIndex(p => {
      return isEmpty(p.id);
    });

    if (index >= 0) places[index] = cloneDeep(updatedPlace);

    this.setState({ places, place, updateData });
  };

  onUpdatePlaceData = (key, value) => {
    // Internal Update
    const { place = {} } = cloneDeep(this.state);

    place[key] = value;

    this.onUpdateInternalStates(place);
  };

  onUpdatePlaceAddress = whereValue => {
    const { place = {} } = cloneDeep(this.state);

    place.where = whereValue;
    this.onUpdateInternalStates(place);
  };

  onUpdatePlaceNote = note => {
    const { place = {} } = cloneDeep(this.state);

    place.note = note;
    this.onUpdateInternalStates(place);
  };

  onUploadPlaceMedia = files => {
    // TODO: Implement me
  };

  onClearPlaceMedia = () => {
    // TODO: Implement me
  };

  onCreatePlace = () => {
    let { place, places } = cloneDeep(this.state);
    // Internal update
    let updateData = { status: 'active', media: { type: 'image', url: '' } };

    // This indicates there is already an unsaved place
    let found = places.find(l => {
      return !l.id || l.id === '';
    });
    if (found) return;

    place = cloneDeep(updateData);

    places.push(place);

    this.setState({
      places,
      place,
      updateData,
    });
    this.setUnsavedDataFlag(updateData);
  };

  setUnsavedDataFlag(unsavedData) {
    if (!isEmpty(unsavedData)) this.props.setUnsavedDataFlagFunc(true);
  }

  onSavePlace = () => {
    // External update
    let ud = cloneDeep(this.state.updateData);

    if (isEmpty(ud) || !this.state.place) return;
    if (this.state.place.id) ud.id = this.state.place.id;

    const { media = { url: '' }, medias = [] } = ud;

    if (!isEmpty(media.url)) {
      if (!isLastMediaSame(medias, media)) medias.push(cloneDeep(media));
      delete ud.media;
      ud.medias = medias;
    }

    if (ud.id) {
      this.props.patchPlaceFunc(ud);
    } else {
      if (!ud.name) {
        this.setState({
          openAlertDialog: true,
          errors: ['Please enter a place name to save.'],
        });
        return;
      }
      this.props.postPlaceFunc(ud);
    }

    this.setState({
      updateData: {},
    });
    this.resetUnSavedDataFlag();
  };

  resetUnSavedDataFlag() {
    this.props.setUnsavedDataFlagFunc(false);
  }

  renderPlaceList(places, place) {
    return (
      <div className={styles.left} key="placeList">
        <PlaceList
          searchText={this.state.searchText}
          places={places}
          place={place}
          onChangeSearchTextFunc={this.onChangeSearchText}
          onCreatePlaceFunc={this.onCreatePlace}
          onSelectPlaceFunc={this.onSelectPlace}
        />
      </div>
    );
  }

  renderAlertDialog(errors) {
    return (
      <div>
        <Dialog open={this.state.openAlertDialog} aria-labelledby="draggable-dialog-title">
          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            Alert
          </DialogTitle>
          <DialogContent>
            {errors.map(e => {
              return <DialogContentText>{e}</DialogContentText>;
            })}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onClickAlertDialogClose} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  renderConfirmDialog() {
    return (
      <div>
        <Dialog open={this.state.openDialog} aria-labelledby="draggable-dialog-title">
          <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
            Confirm
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              The data has not been saved yet. Are you sure to leave?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onClickDialogYes} color="primary">
              Yes
            </Button>
            <Button onClick={this.onClickDialogNo} color="primary">
              No
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  renderPlaceDetails(place) {
    const { placeMedia } = this.props;
    return (
      <div
        className={styles.center}
        onBlur={() => this.setUnsavedDataFlag(this.state.updateData)}
        key={place.id || ''}
      >
        <PlaceDetails
          onUpdatePlaceDataFunc={this.onUpdatePlaceData}
          onUpdatePlaceAddressFunc={this.onUpdatePlaceAddress}
          onUpdatePlaceNoteFunc={this.onUpdatePlaceNote}
          onUploadPlaceMediaFunc={this.onUploadPlaceMedia}
          onClearPlaceMediaFunc={this.onClearPlaceMedia}
          place={place}
          media={placeMedia}
          uploadMediaFunc={this.props.uploadMediaFunc}
        />
      </div>
    );
  }

  render() {
    let components = [];
    const { places, place, updateData, errors } = cloneDeep(this.state);
    let isEnabled = !isEmpty(updateData);

    components.push(this.renderPlaceList(places, place));
    if (!isEmpty(place)) {
      components.push(this.renderPlaceDetails(place));
    }

    return (
      <div className={styles.root}>
        {components}
        <ACSaveBar isEnabled={isEnabled} onSaveFunc={this.onSavePlace} />
        {this.renderConfirmDialog()}
        {this.renderAlertDialog(errors)}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getPlacesFunc: filterParams => dispatch(getPlaces(filterParams)),
    getPlaceFunc: filterParams => dispatch(getPlace(filterParams)),

    postPlaceFunc: place => dispatch(postPlace(place)),
    patchPlaceFunc: place => dispatch(patchPlace(place)),

    uploadMediaFunc: (mediaFor, mediaType, file) =>
      dispatch(uploadMedia(mediaFor, mediaType, file)),
  };
};

const mapStateToProps = state => {
  const statePlaces = state.places;
  const stateMedias = state.medias || {};

  const { media = {} } = stateMedias;
  const { ui = '' } = media;
  const placeMedia = ui === getMediaForUIName().place ? media : {};

  const { isRefreshRequired = false, places = [], place = {}, error } = statePlaces;

  if (statePlaces) {
    if (!isEmpty(error)) {
      console.log(error.message);
    }
  }

  return {
    places,
    place,
    isRefreshRequired,
    placeMedia,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlacesPage);
